import {
  deleteAttendanceFace,
  registerAttendanceFace,
  uploadAttendanceFaceImage
} from '@/api/attendanceFaceEnrollment'

export default {
  namespaced: true,
  state: {
    uploading: false,
    registering: false,
    deleting: false,
    lastUpload: null,
    lastRegistration: null,
    lastDeletion: null,
    error: null
  },
  getters: {
    uploading: state => state.uploading,
    registering: state => state.registering,
    deleting: state => state.deleting,
    lastUpload: state => state.lastUpload,
    lastRegistration: state => state.lastRegistration,
    lastDeletion: state => state.lastDeletion,
    error: state => state.error
  },
  mutations: {
    SET_UPLOADING(state, value) {
      state.uploading = !!value
    },
    SET_REGISTERING(state, value) {
      state.registering = !!value
    },
    SET_DELETING(state, value) {
      state.deleting = !!value
    },
    SET_LAST_UPLOAD(state, payload) {
      state.lastUpload = payload || null
    },
    SET_LAST_REGISTRATION(state, payload) {
      state.lastRegistration = payload || null
    },
    SET_LAST_DELETION(state, payload) {
      state.lastDeletion = payload || null
    },
    SET_ERROR(state, error) {
      state.error = error || null
    }
  },
  actions: {
    async uploadImage({ commit }, file) {
      commit('SET_UPLOADING', true)
      commit('SET_ERROR', null)
      try {
        const response = await uploadAttendanceFaceImage(file)
        commit('SET_LAST_UPLOAD', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Upload attendance face image failed')
        throw error
      } finally {
        commit('SET_UPLOADING', false)
      }
    },
    async registerPerson({ commit }, payload) {
      commit('SET_REGISTERING', true)
      commit('SET_ERROR', null)
      try {
        const response = await registerAttendanceFace(payload)
        commit('SET_LAST_REGISTRATION', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Register attendance face failed')
        throw error
      } finally {
        commit('SET_REGISTERING', false)
      }
    },
    async deletePerson({ commit }, payload) {
      commit('SET_DELETING', true)
      commit('SET_ERROR', null)
      try {
        const response = await deleteAttendanceFace(payload)
        commit('SET_LAST_DELETION', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Delete attendance face failed')
        throw error
      } finally {
        commit('SET_DELETING', false)
      }
    }
  }
}
